import * as React from 'react';

import { cn } from '../utils/cn';

const badgeStyles = {
  default: 'bg-primary/10 text-primary border border-transparent',
  outline: 'border border-border text-foreground',
  success: 'bg-success/10 text-success border border-transparent',
  destructive: 'bg-destructive/10 text-destructive border border-transparent',
  info: 'bg-info/10 text-info border border-transparent',
  warning: 'bg-warning/10 text-warning border border-transparent',
  muted: 'bg-muted/20 text-muted-foreground border border-border/60'
};

export type BadgeVariant = keyof typeof badgeStyles;

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(({ className, variant = 'default', ...props }, ref) => (
  <span ref={ref} className={cn('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium', badgeStyles[variant], className)} {...props} />
));

Badge.displayName = 'Badge';
